import { Button, Dialog, DialogContent, DialogTitle, makeStyles } from "@material-ui/core";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import MaterialTable from "material-table";
import moment from "moment";
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { CommonUrl, logoutMsg, myHeaderStyle, mySearchFieldStyle, NONCE, processMsg, TIME_STAMP } from "../common-url/CommonUrl";

const useStyles = makeStyles(theme => ({
    root: {
        "& .MuiInput-underline:before": {
            borderBottom: 0,
        },
        "& .MuiInput-underline:after": {
            borderBottom: 0,
        },
        "& .MuiInput-root": {
            borderBottom: 0,
        },
        "&:last-child td": {
        },
    }
}));


export default function Faq() {

    const [faq, setFaq] = useState([]);
    const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
    const history = useHistory();
    const classes = useStyles();
    const columns = [
        { title: "Sr No", render: rowData => rowData.tableData.id + 1, width: "10%" },
        {
            title: "Title", field: "vTitle",
            cellStyle: {
                width: 200,
                minWidth: 200,
                textAlign: "justify",
            },
            headerStyle: {
                width: 200,
                minWidth: 200
            },
        },
        {
            title: "Description", field: "vDescription",
            cellStyle: {
                width: 550,
                minWidth: 550,
                textAlign: "justify"
            },
            headerStyle: {
                width: 550,
                minWidth: 550
            },
            validate: rowData => (rowData.vDescription ? true : 'Description Required')
        },
        {
            title: "Created At", field: "iCreatedAt", editable: false, filtering: false,
            render: rowData => <span>{moment(rowData.iCreatedAt * 1000).format('MMMM Do YYYY, h:mm:ss a')}</span>
        },
        {
            title: "Updated At", field: "iUpdatedAt", editable: false, filtering: false,
            render: rowData => <span>{moment(rowData.iUpdatedAt * 1000).format('MMMM Do YYYY, h:mm:ss a')}</span>
        }
    ]
    // -------------------------------------------------------------------
    // -------------get the all FAQ list at initial loading---------------
    // -------------------------------------------------------------------
    const myTextIcon = React.useRef(null);

    useEffect(() => {
        fetchFaq();
        myTextIcon.current.parentNode.parentNode.classList.remove('MuiIconButton-root');
    }, [])

    const fetchFaq = async () => {
        setLoading(false);
        await fetch(CommonUrl.faqBaseUrl + "/view", {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            }
        }).then(response => response.json())
            .then(response => {
                if (response.code == 401) {
                    history.push("/logout");
                    toast.info(logoutMsg, { autoClose: 5000 })
                } else {
                    setFaq(response.data)
                }
            });
    }
    // -------------------------------------------------------------------
    // -----------------------adding a faq-------------------------------
    // -------------------------------------------------------------------
    const [loading, setLoading] = useState(false);

    const handleRowAdd = (e) => {
        e.preventDefault();
        setLoading(true);
        const id = toast.loading(processMsg);
        fetch(CommonUrl.faqBaseUrl + "/add", {
            method: "post",
            headers: {
                'Content-Type': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            },
            body: JSON.stringify({
                vTitle: formData.vTitle,
                vDescription: formData.vDescription,
            })
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 })
                handleClose();
                fetchFaq();
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 })
            }
        })
    }
    // -------------------------------------------------------------------
    // ------------------------delete a faq-------------------------------
    // -------------------------------------------------------------------

    const handleRowDelete = (roomTableDeleteID) => {
        const id = toast.loading(processMsg)
        fetch(CommonUrl.faqBaseUrl + "/delete", {
            method: "delete",
            headers: {
                'Content-Type': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            },
            body: JSON.stringify({
                _id: roomTableDeleteID
            })
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                fetchFaq();
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 },)
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 },)
            }
        })
    }
    // -------------------------------------------------------------------
    // -----------------------update a faq--------------------------------
    // -------------------------------------------------------------------
    const handleRowUpdate = (e) => {
        e.preventDefault();
        setLoading(true);
        const id = toast.loading(processMsg)
        fetch(CommonUrl.faqBaseUrl + "/update", {
            method: "put",
            headers: {
                'Content-Type': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            },
            body: JSON.stringify({
                _id: formData._id,
                vTitle: formData.vTitle,
                vDescription: formData.vDescription
            })
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 },)
                handleClose();
                fetchFaq();
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 },)
            }
        })
    }
    // -------------------------------------------------------------------
    //-------------------- snackbar operations ---------------------------
    // -------------------------------------------------------------------

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenForm(false)
        setTimeout(() => {
            setFormData({})
        }, 200);
    };

    const [openForm, setOpenForm] = useState(false)
    const [formData, setFormData] = useState({})

    const openAddForm = () => {
        setOpenForm(true)

    }
    const openUpdateForm = (rowData) => {
        setOpenForm(true)
        setFormData(rowData)
    }
    // -------------------------------------------------------------------
    // -------------------------------------------------------------------

    return (
        <div className="App">
            <Dialog open={openForm} onClose={handleClose}>
                <div className="p-5">
                    <DialogTitle id="alert-dialog-title" className="text-center "><span className="text-primary">{formData._id ? ("Update") : ("Add")}</span> FAQ</DialogTitle>
                    <form onSubmit={formData._id ? (handleRowUpdate) : (handleRowAdd)} >
                        <DialogContent>
                            <hr className="solid mt-0 mb-5"></hr>
                            <div className="">
                                <label className="col-sm-3 col-form-label">Title</label>
                                <input className="form-control" placeholder="Enter Title" type="text" defaultValue={formData._id ? (formData.vTitle) : (null)}
                                    onInvalid={(e) => e.target.setCustomValidity('Enter the Title')}
                                    onInput={(e) => e.target.setCustomValidity('')}
                                    onChange={(e) => setFormData({ ...formData, vTitle: e.target.value })}
                                    required></input>
                            </div>
                        </DialogContent>
                        <DialogContent>
                            <div className="form-group">
                                <label className="col-sm-3 col-form-label">Description</label>
                                <textarea className="form-control" placeholder="Enter Description" defaultValue={formData._id ? (formData.vDescription) : (null)} rows="4"
                                    onInvalid={(e) => e.target.setCustomValidity('Enter the Description')}
                                    onInput={(e) => e.target.setCustomValidity('')}
                                    onChange={(e) => setFormData({ ...formData, vDescription: e.target.value })} required ></textarea>
                            </div>
                        </DialogContent>
                        <div className=" row form-group justify-content-sm-center">
                            <Button type="submit" disabled={loading} className="col-sm-4 btn btn-light-primary px-9 py-3 my-3">
                                <span>Submit</span>
                                {loading && <span className="ml-3 spinner spinner-dark"></span>}
                            </Button>
                        </div>
                    </form>
                </div>
            </Dialog>
            {/* material table starts */}
            <div className={classes.root} >
                <MaterialTable title="FAQ List"
                    style={{ paddingInline: "30px", paddingTop: "10px" }}
                    data={faq}
                    columns={columns}
                    actions={[
                        {
                            icon: () => <div ref={myTextIcon}><button className="btn  btn-light-primary mx-6">Add +</button></div>,
                            iconProps: { color: "secondary" },
                            tooltip: 'Add FAQ',
                            isFreeAction: true,
                            onClick: () => {
                                openAddForm()
                            }
                        },
                        {
                            icon: 'edit',
                            tooltip: 'Update FAQ',
                            iconProps: { color: "secondary" },
                            onClick: (e, rowData) => {
                                openUpdateForm(rowData)
                            }
                        },
                    ]}
                    icons={{
                        Delete: () => <DeleteOutlineIcon style={{ color: "#f64e60" }} />
                    }}
                    editable={{
                        onRowDelete: selectedRow => new Promise((resolve, reject) => {
                            const roomTableDeleteID = (selectedRow._id)
                            handleRowDelete(roomTableDeleteID);
                            resolve();
                        }),
                    }}
                    onRowClick={(evt, rowData) => { openUpdateForm(rowData) }}
                    options={{
                        actionsColumnIndex: -1,
                        addRowPosition: "first",
                        headerStyle: myHeaderStyle,
                        searchFieldStyle: mySearchFieldStyle,
                        emptyRowsWhenPaging: false, // To avoid of having empty rows
                    }}
                />
            </div>
            {/* material table ends */}
        </div>
    )
}
